import { Component } from 'preact';
import { connect } from 'unistore/preact';
import { commas } from '../../utils/common';
import { fetchPcfForAllPayModes } from '../../controllers/pcf';
import ConvenienceHelp from '../convHelp';
import { locale } from '../../utils/i18n';
import { RupeeSymbol } from '../rupeeSymbol';
import CONSTANT from '../../utils/constants';

class ConvenienceCharge extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAllModePcfDetailsVisible: false,
      convChargeDetails: {}
    };
  }

  componentDidMount() {
    document.addEventListener('mouseup', this.mouseDownEvent);
    let txnAmount = 0;
    if (this.props.cache.getData(CONSTANT.IS_EMISUBVENTION_ACCESS_TOKEN_FLOW)) {
      txnAmount = this.props.cache.getData(CONSTANT.TXN_AMOUNT);
    }
    fetchPcfForAllPayModes(this.props.cache, txnAmount)
      .then(convChargeDetails => {
        this.setState({ convChargeDetails });
      })
      .catch(() => {
        this.setState({ convChargeDetails: {} });
      });
  }

  toggleHelp = () => {
    this.setState(prevState => ({
      isAllModePcfDetailsVisible: !prevState.isAllModePcfDetailsVisible
    }));
  };

  closeHelp = () => {
    this.setState({ isAllModePcfDetailsVisible: false });
  };

  componentDidUpdate(previousProps) {
    if (
      this.props.headerFixClass !== previousProps.headerFixClass &&
      this.state.isAllModePcfDetailsVisible
    ) {
      this.closeHelp();
    }
  }

  mouseDownEvent = e => {
    if (e) {
      this.closeHelp();
      e.stopPropagation();
    }
  };

  componentWillUnmount() {
    document.removeEventListener('mouseup', this.mouseDownEvent);
  }

  cnvBoxClick = e => {
    e.stopPropagation();
  };

  render({ pcfFeeAmount }, { isAllModePcfDetailsVisible, convChargeDetails }) {
    let intPart;
    let floatPart;
    if (pcfFeeAmount && !Number.isNaN(pcfFeeAmount)) {
      const feeAmountArr = commas(pcfFeeAmount).split('.');
      intPart = feeAmountArr[0] || '0';
      floatPart = feeAmountArr[1] || '00';
    }

    return (
      <section className={`ptm-con-subheading ptm-header-color`}>
        {pcfFeeAmount !== 0 && (
          <div>
            {isAllModePcfDetailsVisible && (
              <span onMouseUp={this.cnvBoxClick}>
                <ConvenienceHelp {...{ convChargeDetails }} />
              </span>
            )}
            <p class={`ptm-c-p`} onMouseUp={this.cnvBoxClick}>
              <label onClick={this.toggleHelp}>
                {locale('pcf.inclusive')} <RupeeSymbol />
                <span class="ib ptm-vt">
                  <span class={`ptm-semibold`}>{intPart}</span>
                  <span class={`decimal sub-txt-header-global`}>.{floatPart}</span>
                </span>
                <span>({locale('pcf.convenience.gst')}) </span>
                <span class={`ptm-arrow-down`} />
              </label>
            </p>
          </div>
        )}
      </section>
    );
  }
}

export default connect('cache')(ConvenienceCharge);



// WEBPACK FOOTER //
// ./components/convenienceChg/index.js